import { AppColors } from "@/styles/colors";
import { Button, Flex, Text } from "@chakra-ui/react";
import { Check, ChevronLeft, Info, X } from "lucide-react";

interface Props {
  isPendingStatus: boolean;
  loadingStartReview: boolean;
  approveDisabled: boolean;
  requireChangesDisabled: boolean;
  showApprove?: boolean;
  showRequireChanges?: boolean;
  onStartReview: () => void;
  onApprove: () => void;
  onRequireChanges: () => void;
  onBack: () => void;
}

export const HeaderActions = ({
  isPendingStatus,
  loadingStartReview,
  approveDisabled,
  requireChangesDisabled,
  showApprove = true,
  showRequireChanges = true,
  onStartReview,
  onApprove,
  onRequireChanges,
  onBack,
}: Props) => {
  return (
    <Flex gap="12px" alignItems="center">
      {showApprove && (
        <Button
          paddingX="12px"
          height="32px"
          bgColor={
            isPendingStatus
              ? AppColors.BLACK_TEXT_SECONDARY
              : AppColors.GREEN_PRIMARY
          }
          onClick={isPendingStatus ? onStartReview : onApprove}
          loading={isPendingStatus ? loadingStartReview : false}
          disabled={
            isPendingStatus
              ? loadingStartReview
              : approveDisabled
          }
        >
          {isPendingStatus ? <Info /> : <Check />}
          <Text fontWeight={600} fontSize="14px">
            {isPendingStatus ? "En revisión" : "Aprobar"}
          </Text>
        </Button>
      )}

      {showRequireChanges && (
        <Button
          paddingX="12px"
          height="32px"
          bgColor={AppColors.RED_ICON}
          onClick={onRequireChanges}
          disabled={requireChangesDisabled}
        >
          <X />
          <Text fontWeight={600} fontSize="14px">
            Requerir cambios
          </Text>
        </Button>
      )}

      <Button
        paddingX="12px"
        height="32px"
        bgColor={AppColors.BLACK_TEXT_SECONDARY}
        color={AppColors.WHITE_SECONDARY}
        _hover={{ bgColor: AppColors.BLACK_TEXT_SECONDARY }}
        _active={{ bgColor: AppColors.BLACK_TEXT_SECONDARY }}
        onClick={onBack}
      >
        <ChevronLeft />
        <Text fontWeight={600} fontSize="14px">
          Volver
        </Text>
      </Button>
    </Flex>
  );
};
